export default function PHP_hexdec() {
  return (
    <div>
      <h1>PHP_hexdec</h1>
    </div>
  );
}
